<template>
  <div
    v-if="apiKey && location"
    data-test="usgooglemapembed"
    class="us-googlemap-embed border-radius--1"
    :style="`--aspect-ratio: ${arNumber}`"
  >
    <iframe loading="lazy" allowfullscreen :src="src"></iframe>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'USGoogleMapEmbed',
  props: {
    location: { type: String, required: true },
    apiKey: {
      type: String,
      required: true
    },
    aspectRatio: {
      type: String as PropType<'16:9' | '9:16' | '4:3' | '3:4' | '1:1'>,
      default: '16:9',
      filter: (val: string) => {
        return ['16:9', '9:16', '4:3', '3:4', '1:1'].includes(val)
      }
    }
  },
  computed: {
    arNumber(): number {
      const arDimensions: string[] = this.aspectRatio.split(':')

      return parseInt(arDimensions[0]) / parseInt(arDimensions[1])
    },
    src(): string {
      return `https://www.google.com/maps/embed/v1/place?key=${
        this.apiKey
      }&q=${encodeURIComponent(this.location)}`
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@base/@motiv/fe-patterns/styles/aspect-ratio' as *;

.us-googlemap-embed {
  --aspect-ratio: 16/9;

  @include aspect-ratio($ar: var(--aspect-ratio), $fit-child: true);

  width: 100%;

  // aspect ratio default

  iframe {
    height: 100%;
    width: 100%;
  }
}
</style>
